// extracted by mini-css-extract-plugin
export default {"invalid-error":"InvoiceForm_invalid-error__rJBDp","submitBtn":"InvoiceForm_submitBtn__dNjz0","btn":"InvoiceForm_btn__KFIDu","margin":"InvoiceForm_margin__5zUsj"};